import { shape } from 'prop-types';
import { arrayOf, string, number } from 'prop-types';

export const checkoutAnswerTypes = {
  checkoutAnswers: arrayOf(
    shape({
      checkoutQuestionId: number,
      checkoutQuestion: string,
      answer: string
    })
  )
};
